import { render, staticRenderFns } from "./ReservesCard.vue?vue&type=template&id=42dd0ec2&scoped=true"
import script from "./ReservesCard.vue?vue&type=script&lang=ts"
export * from "./ReservesCard.vue?vue&type=script&lang=ts"
import style0 from "./ReservesCard.vue?vue&type=style&index=0&id=42dd0ec2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dd0ec2",
  null
  
)

export default component.exports